<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="handleSearch">
        <a-row :gutter="24">
<!--          <a-col :md="6" :sm="12">-->
<!--            <a-form-item label="渠道">-->
<!--              <a-select-->
<!--                  v-model="filters.channel"-->
<!--                  placeholder="请选择渠道"-->
<!--                  allowClear-->
<!--                  style="width: 100%">-->
<!--                <a-select-option value="internal">内部渠道</a-select-option>-->
<!--                <a-select-option value="external">外部渠道</a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--          </a-col>-->

          <a-col :md="6" :sm="12">
            <a-form-item label="站点名称">
              <a-select
                  v-model="filters.siteName"
                  placeholder="请选择站点"
                  allowClear
                  show-search
                  :filter-option="filterOption"
                  style="width: 100%">
                <a-select-option
                    v-for="item in selectedItems"
                    :key="item.id"
                    :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="12" :xs="24">
            <a-form-item label="时间范围" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
              <a-range-picker
                  v-model="filters.dateRange"
                  style="width: 100%"
                  :show-time="{ format: 'HH:mm:ss', defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')] }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onDateChange"
                  @ok="onDateOk"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleSearch" icon="search" :loading="loading">查询</a-button>
              <a-button @click="handleReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleRefresh" type="primary" icon="reload" :loading="loading">刷新</a-button>
    </div>

    <!-- 数据统计表格 -->
    <div class="table-section">
      <a-card>
        <template #title>
          <span>各时间段妥投数据统计</span>
          <span class="total-quantity-badge">总单量：{{ totalQuantity.toLocaleString() }}</span>
        </template>
        <a-table
            :columns="tableColumns"
            :data-source="tableData"
            :pagination="false"
            :loading="loading"
            size="small"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'deliveryRate'">
              {{ record.deliveryRate }}%
            </template>
          </template>
        </a-table>
      </a-card>
    </div>

    <!-- 总计统计区域 -->
    <div class="statistics-section">
      <a-card title="总计统计">
        <a-row :gutter="16">
          <a-col :span="6">
            <div class="statistic-item">
              <div class="statistic-title">总单量</div>
              <div class="statistic-value">{{ totalStatistics.totalOrders.toLocaleString() }}</div>
            </div>
          </a-col>
          <a-col :span="6">
            <div class="statistic-item">
              <div class="statistic-title">妥投单量</div>
              <div class="statistic-value">{{ totalStatistics.deliveredOrders.toLocaleString() }}</div>
            </div>
          </a-col>
          <a-col :span="6">
            <div class="statistic-item">
              <div class="statistic-title">妥投率</div>
              <div class="statistic-value">{{ totalStatistics.deliveryRate }}%</div>
            </div>
          </a-col>
          <a-col :span="6">
            <div class="statistic-item">
              <div class="statistic-title">未妥投单量</div>
              <div class="statistic-value">{{ totalStatistics.undeliveredOrders.toLocaleString() }}</div>
            </div>
          </a-col>
        </a-row>
      </a-card>
    </div>

    <!-- 图表区域 -->
    <div class="chart-section">
      <a-row :gutter="16">
        <!-- 饼图 -->
        <a-col :span="12">
          <a-card title="妥投时间段分布">
            <div ref="pieChart" style="width: 100%; height: 300px;"></div>
          </a-card>
        </a-col>
        <!-- 折线图 -->
        <a-col :span="12">
          <a-card>
            <div class="trend-title">妥投趋势分析</div>
            <div ref="lineChart" style="height: 300px; margin-top: 16px;"></div>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </a-card>
</template>

<script>
import * as echarts from 'echarts'
import {getDeliveryReportStatistics} from '@/api/delivery'
import {mapGetters} from 'vuex'

export default {
  name: 'DeliveryReport',
  data() {
    return {
      loading: false,
      trendType: 'daily',
      // 筛选条件
      filters: {
        channel: undefined,
        siteName: undefined,
        dateRange: [],
        startTime: undefined,
        endTime: undefined
      },

      // 站点数据
      selectedItems: [],
      selectedItemsAll: [],

      // 表格列定义
      tableColumns: [
        {
          title: '妥投时间段',
          dataIndex: 'timePeriod',
          key: 'timePeriod',
          width: 120
        },
        {
          title: '妥投单量',
          dataIndex: 'deliveredOrders',
          key: 'deliveredOrders',
          width: 100,
          align: 'right'
        },
        {
          title: '未妥投单量',
          dataIndex: 'undeliveredOrders',
          key: 'undeliveredOrders',
          width: 120,
          align: 'right'
        },
        {
          title: '妥投率',
          dataIndex: 'deliveryRate',
          key: 'deliveryRate',
          width: 150,
          align: 'center'
        }
      ],
      // 表格数据
      tableData: [],
      // 总单量
      totalQuantity: 0,
      // 总计数据
      totalStatistics: {
        totalOrders: 0,
        deliveredOrders: 0,
        deliveryRate: 0,
        undeliveredOrders: 0
      },
      // 饼图实例
      pieChartInstance: null,
      lineChartInstance: null
    }
  },

  methods: {
    ...mapGetters(["siteInfo"]),
    // 站点搜索过滤方法
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    // 初始化饼图
    initPieChart() {
      if (this.$refs.pieChart) {
        this.pieChartInstance = echarts.init(this.$refs.pieChart)

        const option = {
          title: {
            text: '妥投率分布',
            left: 'center',
            textStyle: {
              fontSize: 16,
              fontWeight: 'bold'
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c}'
          },
          legend: {
            orient: 'vertical',
            left: 'left'
          },
          series: [
            {
              name: '妥投状态',
              type: 'pie',
              radius: '50%',
              data: [
                {value: 0, name: '已妥投'},
                {value: 0, name: '未妥投'}
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }

        this.pieChartInstance.setOption(option)
      }
    },

    // 初始化折线图
    initLineChart() {
      if (this.$refs.lineChart) {
        this.lineChartInstance = echarts.init(this.$refs.lineChart)

        const option = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['妥投率', '总单量'],
            top: 10
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '8%',
            top: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: []
          },
          yAxis: [
            {
              type: 'value',
              name: '妥投率(%)',
              position: 'left',
              axisLabel: {
                formatter: '{value}%'
              },
              nameTextStyle: {
                padding: [0, 0, 0, 0]
              }
            },
            {
              type: 'value',
              name: '单量',
              position: 'right',
              axisLabel: {
                formatter: function (value) {
                  if (value >= 1000) {
                    return (value / 1000).toFixed(1) + 'k'
                  }
                  return value
                },
                margin: 8
              },
              nameTextStyle: {
                padding: [0, 0, 0, 10]
              },
              nameGap: 25
            }
          ],
          series: [
            {
              name: '妥投率',
              type: 'line',
              yAxisIndex: 0,
              data: [],
              smooth: true,
              itemStyle: {
                color: '#1890ff'
              }
            },
            {
              name: '总单量',
              type: 'line',
              yAxisIndex: 1,
              data: [],
              smooth: true,
              itemStyle: {
                color: '#52c41a'
              }
            }
          ]
        }

        this.lineChartInstance.setOption(option)
      }
    },

    // 更新趋势图
    async updateTrendChart() {
      try {
        // 调用真实接口
        const params = {
          internalChannel: this.filters.channel === 'internal' ? true : undefined,
          externalChannel: this.filters.channel === 'external' ? true : undefined,
          startDate: this.filters.startTime,
          endDate: this.filters.endTime,
          type: this.trendType || 'daily'
        }

        const response = await getDeliveryReportStatistics(params)

        // 处理折线图数据
        const trendData = {
          dates: response.data.lineList.map(item => item.days),
          deliveryRates: response.data.lineList.map(item => item.percent),
          totalOrders: response.data.lineList.map(item => item.quantity)
        }

        if (this.lineChartInstance) {
          const option = {
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['妥投率', '总单量'],
              top: 10
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '8%',
              top: '15%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: trendData.dates
            },
            yAxis: [
              {
                type: 'value',
                name: '妥投率(%)',
                position: 'left',
                axisLabel: {
                  formatter: '{value}%'
                },
                nameTextStyle: {
                  padding: [0, 0, 0, 0]
                }
              },
              {
                type: 'value',
                name: '单量',
                position: 'right',
                axisLabel: {
                  formatter: function (value) {
                    if (value >= 1000) {
                      return (value / 1000).toFixed(1) + 'k'
                    }
                    return value
                  },
                  margin: 8
                },
                nameTextStyle: {
                  padding: [0, 0, 0, 10]
                },
                nameGap: 25
              }
            ],
            series: [
              {
                name: '妥投率',
                type: 'line',
                yAxisIndex: 0,
                data: trendData.deliveryRates,
                smooth: true,
                itemStyle: {
                  color: '#1890ff'
                }
              },
              {
                name: '总单量',
                type: 'line',
                yAxisIndex: 1,
                data: trendData.totalOrders,
                smooth: true,
                itemStyle: {
                  color: '#52c41a'
                }
              }
            ]
          }

          this.lineChartInstance.setOption(option, true)
        }
      } catch (error) {
        console.error('更新趋势图失败:', error)
      }
    },

    // 查询数据
    async handleSearch() {
      this.loading = true
      try {
        // 调用真实接口
        const params = {
          channel: this.filters.channel === 'internal' ? true : undefined,
          siteId: this.filters.siteName,
          startDate: this.filters.startTime,
          endDate: this.filters.endTime,
        }

        const response = await getDeliveryReportStatistics(params)

        // 设置总单量
        this.totalQuantity = response.data.totalQuantity || 0

        // 处理表格数据，过滤掉总计行
        const allData = response.data.list.map(item => ({
          timePeriod: item.days,
          deliveredOrders: item.totalQuantity,
          deliveryRate: item.percent,
          undeliveredOrders: item.notDeliveredYetQuantity
        }))

        // 过滤掉总计行
        this.tableData = allData.filter(item => item.timePeriod !== '各时间段妥投数据统计')

        // 更新总计数据
        // if (totalRow) {
        //   this.totalStatistics = {
        //     deliveredOrders: totalRow.deliveredOrders,
        //     deliveryRate: totalRow.deliveryRate,
        //     undeliveredOrders: totalRow.undeliveredOrders
        //   }
        // }
        if (response.data && response.data.overall) {
          this.totalStatistics = {
            totalOrders: response.data.overall.totalQuantity,
            deliveredOrders: response.data.overall.deliveredYetQuantity,
            deliveryRate: response.data.overall.percent,
            undeliveredOrders: response.data.overall.notDeliveredYetQuantity
          }
        }

        // 等待DOM更新
        await this.$nextTick()

        // 更新饼图数据
        if (this.pieChartInstance) {
          // 处理饼图数据
          const pieData = response.data.pieList.map(item => ({
            name: item.days,
            value: item.quantity
          }))
          const option = {
            series: [{
              data: pieData
            }]
          }
          this.pieChartInstance.setOption(option)
        }

        // 更新折线图数据
        if (this.lineChartInstance) {
          // 处理折线图数据
          const trendData = {
            dates: response.data.lineList.map(item => item.days),
            deliveryRates: response.data.lineList.map(item => item.percent),
            totalOrders: response.data.lineList.map(item => item.quantity)
          }
          const option = {
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['妥投率', '总单量'],
              top: 10
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '8%',
              top: '15%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: trendData.dates
            },
            yAxis: [
              {
                type: 'value',
                name: '妥投率(%)',
                position: 'left',
                axisLabel: {
                  formatter: '{value}%'
                },
                nameTextStyle: {
                  padding: [0, 0, 0, 0]
                }
              },
              {
                type: 'value',
                name: '单量',
                position: 'right',
                axisLabel: {
                  formatter: function (value) {
                    if (value >= 1000) {
                      return (value / 1000).toFixed(1) + 'k'
                    }
                    return value
                  },
                  margin: 8
                },
                nameTextStyle: {
                  padding: [0, 0, 0, 10]
                },
                nameGap: 25
              }
            ],
            series: [
              {
                name: '妥投率',
                type: 'line',
                yAxisIndex: 0,
                data: trendData.deliveryRates,
                smooth: true,
                itemStyle: {
                  color: '#1890ff'
                }
              },
              {
                name: '总单量',
                type: 'line',
                yAxisIndex: 1,
                data: trendData.totalOrders,
                smooth: true,
                itemStyle: {
                  color: '#52c41a'
                }
              }
            ]
          }
          this.lineChartInstance.setOption(option, true)
        }

        this.$message.success('查询成功')
      } catch (error) {
        console.error('查询失败:', error)
        this.$message.error('查询失败，请重试')
      } finally {
        this.loading = false
      }
    },

    // 加载初始数据
    async loadInitialData() {
      try {
        // 调用真实接口
        const params = {
          internalChannel: this.filters.channel === 'internal' ? true : undefined,
          externalChannel: this.filters.channel === 'external' ? true : undefined,
          startDate: this.filters.startTime,
          endDate: this.filters.endTime,
          type: 'daily'
        }

        const response = await getDeliveryReportStatistics(params)

        // 设置总单量
        this.totalQuantity = response.data.totalQuantity || 0

        // 处理表格数据，过滤掉总计行
        const allData = response.data.list.map(item => ({
          timePeriod: item.days,
          deliveredOrders: item.totalQuantity,
          deliveryRate: item.percent,
          undeliveredOrders: item.notDeliveredYetQuantity
        }))

        // 过滤掉总计行
        this.tableData = allData.filter(item => item.timePeriod !== '各时间段妥投数据统计')

        // 更新总计数据
        // if (totalRow) {
        //   this.totalStatistics = {
        //     deliveredOrders: totalRow.deliveredOrders,
        //     deliveryRate: totalRow.deliveryRate,
        //     undeliveredOrders: totalRow.undeliveredOrders
        //   }
        // }
        if (response.data && response.data.overall) {
          this.totalStatistics = {
            totalOrders: response.data.overall.totalQuantity,
            deliveredOrders: response.data.overall.deliveredYetQuantity,
            deliveryRate: response.data.overall.percent,
            undeliveredOrders: response.data.overall.notDeliveredYetQuantity
          }
        }

        // 等待图表初始化完成后更新数据
        await this.$nextTick()

        // 更新图表数据
        if (this.pieChartInstance) {
          // 处理饼图数据
          const pieData = response.data.pieList.map(item => ({
            name: item.days,
            value: item.quantity
          }))

          this.pieChartInstance.setOption({
            series: [{
              name: '妥投状态',
              type: 'pie',
              radius: '50%',
              data: pieData,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          })
        }

        if (this.lineChartInstance) {
          // 处理折线图数据
          const trendData = {
            dates: response.data.lineList.map(item => item.days),
            deliveryRates: response.data.lineList.map(item => item.percent),
            totalOrders: response.data.lineList.map(item => item.quantity)
          }

          const lineOption = {
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['妥投率', '总单量'],
              top: 10
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '8%',
              top: '15%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: trendData.dates
            },
            yAxis: [
              {
                type: 'value',
                name: '妥投率(%)',
                position: 'left',
                axisLabel: {
                  formatter: '{value}%'
                },
                nameTextStyle: {
                  padding: [0, 0, 0, 0]
                }
              },
              {
                type: 'value',
                name: '单量',
                position: 'right',
                axisLabel: {
                  formatter: function (value) {
                    if (value >= 1000) {
                      return (value / 1000).toFixed(1) + 'k'
                    }
                    return value
                  },
                  margin: 8
                },
                nameTextStyle: {
                  padding: [0, 0, 0, 10]
                },
                nameGap: 25
              }
            ],
            series: [
              {
                name: '妥投率',
                type: 'line',
                yAxisIndex: 0,
                data: trendData.deliveryRates,
                smooth: true,
                itemStyle: {
                  color: '#1890ff'
                }
              },
              {
                name: '总单量',
                type: 'line',
                yAxisIndex: 1,
                data: trendData.totalOrders,
                smooth: true,
                itemStyle: {
                  color: '#52c41a'
                }
              }
            ]
          }

          this.lineChartInstance.setOption(lineOption, true)
        }

      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('加载数据失败')
      }
    },

    // 重置搜索条件
    handleReset() {
      // 设置默认时间范围为近一个月
      const endDate = this.$moment().endOf('day')
      const startDate = this.$moment().subtract(1, 'month').startOf('day')
      const dateRange = [startDate, endDate]
      const startTime = startDate.format('YYYY-MM-DD HH:mm:ss')
      const endTime = endDate.format('YYYY-MM-DD HH:mm:ss')
      this.filters = {
        channel: undefined,
        siteName: undefined,
        dateRange: dateRange,
        startTime: startTime,
        endTime: endTime
      }
      this.handleSearch()
    },

    // 刷新数据
    handleRefresh() {
      this.handleSearch()
    },

    // 日期范围变化处理
    onDateChange(value, dateString) {
      this.filters.startTime = dateString[0]
      this.filters.endTime = dateString[1]
    },

    // 日期确认处理
    onDateOk(value) {
      console.log('Date selected:', value)
    }
  },

  mounted() {
    // 初始化站点数据
    this.selectedItemsAll = this.siteInfo()
    this.selectedItems = JSON.parse(JSON.stringify(this.selectedItemsAll))

    // 设置默认时间范围为近一个月
    const endDate = this.$moment().endOf('day')
    const startDate = this.$moment().subtract(1, 'month').startOf('day')
    this.filters.dateRange = [startDate, endDate]
    this.filters.startTime = startDate.format('YYYY-MM-DD HH:mm:ss')
    this.filters.endTime = endDate.format('YYYY-MM-DD HH:mm:ss')

    this.$nextTick(() => {
      // 先初始化图表
      this.initPieChart()
      this.initLineChart()

      // 然后加载数据
      this.loadInitialData()

      // 监听窗口大小变化
      window.addEventListener('resize', () => {
        if (this.pieChartInstance) this.pieChartInstance.resize()
        if (this.lineChartInstance) this.lineChartInstance.resize()
      })
    })
  }
}
</script>

<style lang="less" scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operator {
  margin-bottom: 16px;
}

.delivery-report {
  padding: 16px;

  .page-header {
    margin-bottom: 16px;

    h2 {
      margin: 0;
      font-size: 20px;
      font-weight: 500;
    }
  }

  .filter-section {
    margin-bottom: 16px;
  }

  .table-section {
    margin-bottom: 16px;

    .total-quantity-badge {
      margin-left: 16px;
      padding: 4px 12px;
      background: #f0f2f5;
      border-radius: 16px;
      font-size: 14px;
      color: #1890ff;
      font-weight: 500;
    }
  }

  .statistics-section {
    margin-bottom: 16px;

    .statistic-item {
      text-align: center;
      padding: 16px 0;

      .statistic-title {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        margin-bottom: 8px;
      }

      .statistic-value {
        font-size: 24px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        line-height: 1.2;
      }
    }
  }

  .chart-section {
    .chart-controls {
      margin-bottom: 16px;
      text-align: right;
    }

    .trend-title {
      font-size: 16px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 0;
      padding-bottom: 8px;
      border-bottom: 1px solid #f0f0f0;
    }
  }
}

:deep(.ant-progress-text) {
  font-size: 12px;
}
</style>
